import useApi from "..";

const useBookingApi = () => {
    const { request, isLoading } = useApi();

    const createBooking = (payload) => request('/booking', 'POST', payload)
    const updateBooking = (payload, bookingId) => request(`/booking/update/${bookingId}`, 'PUT', payload)
    const getUserBookings = (limit, offset, status) => request(`/booking/my-booking?limit=${limit}&offset=${offset}&status=${status}`, 'GET', null)
    const getUserBookingDetails = (bookingId) => request(`/booking/${bookingId}/my-booking-details`, 'GET', null)
    const getJobAmendDetails = (bookingId) => request(`/booking/${bookingId}/booking-amendment-detail`, 'GET', null)
    const acceptRejectJobAmendOffer = (bookingAmendId, payload) => request(`/booking/booking-amendment/${bookingAmendId}`, 'PATCH', payload)
    const getMyRequestsForProposal = (limit, offset) => request(`/booking/quoted?limit=${limit}&offset=${offset}`, 'GET', null)
    const createPersonalBooking = (payload) => request('/booking/personal', 'POST', payload)
    const acceptRejectBooking = (bookingId, payload) => request(`/booking/${bookingId}`, 'PATCH', payload)
    const getServiceProviderSelectedServices = (id) => request(`/user/service-provider/${id}/selected-services`, 'GET', null);
    const getServiceProviderProfileDetail = (id, latitude, longitude) => request(`/user/service-provider/${id}?latitude=${latitude}&longitude=${longitude}`, 'GET', null);
    const rateBooking = (bookingId, payload) => request(`/booking/${bookingId}/rate`, 'POST', payload)
    const deleteBooking = (bookingId) => request(`/booking/${bookingId}`, 'DELETE', null)
    const getReceivedUserReviews = (spUserId, limit, offset) => request(`/user/service-provider/${spUserId}/review?limit=${limit}&offset=${offset}`, 'GET', null)
    const replyToUserReview = (payload) => request(`/user/review/reply`, 'POST', payload)
    const getServiceProviderDetailById = (spId) => request(`/user/service-provider/${spId}`, 'GET', undefined)
    

    return {
        createBooking,
        getUserBookings,
        getUserBookingDetails,
        getJobAmendDetails,
        acceptRejectJobAmendOffer,
        getMyRequestsForProposal,
        createPersonalBooking,
        acceptRejectBooking,
        getServiceProviderSelectedServices,
        getServiceProviderProfileDetail,
        rateBooking,
        deleteBooking,
        getReceivedUserReviews,
        replyToUserReview,
        getServiceProviderDetailById,
        updateBooking,
        isLoading
    };
};

export default useBookingApi;
